import { styled } from '@mui/material';
import { TOGGLE, COLOR_SCHEME } from '../toggleConstants.js';

const ToggleTrack = styled("span")(({ theme, $checked, $disabled, $color }) => (Object.assign(Object.assign({ position: "relative", width: TOGGLE.trackWidth, height: TOGGLE.trackHeight, display: "flex", justifyContent: "space-between", alignItems: "center", boxSizing: "border-box", borderRadius: TOGGLE.radius, transition: `background ${TOGGLE.animationDuration} ease-out`, backgroundColor: {
        [COLOR_SCHEME.default]: theme.palette.text.secondary,
        [COLOR_SCHEME.progress]: theme.palette.progress.main,
    }[$color] }, ($disabled && {
    opacity: 0.3,
})), ($checked && {
    backgroundColor: theme.palette.primary[800],
}))));

export { ToggleTrack };
//# sourceMappingURL=ToggleTrack.js.map
